import { useMemo } from 'react'
import { useQuery } from 'react-query'
import QueryKeys from '../utils/constants/queryKeys'
import getPairedCalendarGames from '../Apis/teamPairings/getPairedCalendarGames'
import { PAIRED_EVENT_CLASS } from '../utils/constants/pairedEventStyle'

const titleOf = (game) =>
  game.homeTeam?.name && game.awayTeam?.name ? `${game.homeTeam.name} vs ${game.awayTeam.name}` : game.title

// The paired federation games in the visible range, as calendar events: drawn as blocks (not the
// month view's dots), never draggable, each carrying the federation and competition that read it.
const usePairedCalendarGames = ({ orgId, teamId, range, color, enabled }) => {
  const startAfter = range?.start?.toISOString()
  const endBefore = range?.end?.toISOString()
  const { data } = useQuery(
    [QueryKeys.GET_PAIRED_CALENDAR_GAMES, orgId, teamId, startAfter, endBefore],
    () => getPairedCalendarGames(orgId, teamId, startAfter, endBefore),
    { enabled: Boolean(enabled && orgId && teamId && startAfter && endBefore), retry: false },
  )

  return useMemo(
    () =>
      (data || []).map(({ fedOrgId, competitionId, game }) => ({
        id: game.id,
        start: game.startDateTime,
        end: game.endDateTime,
        title: titleOf(game),
        color,
        display: 'block',
        editable: false,
        classNames: [PAIRED_EVENT_CLASS],
        paired: { orgId: fedOrgId, competitionId },
        extendedProps: { paired: { orgId: fedOrgId, competitionId } },
      })),
    [data, color],
  )
}

export default usePairedCalendarGames
